import { render, staticRenderFns } from "./resetAccount.vue?vue&type=template&id=9329eefc&scoped=true"
import script from "./resetAccount.vue?vue&type=script&lang=js"
export * from "./resetAccount.vue?vue&type=script&lang=js"
import style0 from "./resetAccount.vue?vue&type=style&index=0&id=9329eefc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9329eefc",
  null
  
)

export default component.exports